module.exports = __webpack_public_path__ + "img/xdc.121e00c2.svg";